<template>
  <v-app>

    <!-- /////////////////////////////////////////////////dialog for sign //////////////////////////////////////////// -->
        <v-dialog width="500" persistent v-model="step4">
            <v-card
            class="py-8"
            >
                <v-card-title>
                    <v-row justify="center">
                    
                    </v-row>
                    </v-card-title>
                <v-divider class="mt-1 mb-8"></v-divider>
                <v-card-text>
                    <!--                       //////////////////////////////////////property is residential so have them sign the landlord tenant act    -->
                    <div v-if="residential == true">
                        The following certification applies only to landlords with Residential Property:<br/><br/>
                        <b>DECLARATION OF COMPLIANCE</b><br/>By checking the box below, I certify, to the best of my knowledge, that: 
                        <br/><br/><b>1)</b> The information provided on this form is true and correct; 
                        <br/><br/><b>2)</b> I have listed above all my residential rental properties located in the City of Bremerton; and 
                        <br/><br/><b>3)</b> Each dwelling unit on such property complies with the standards set forth in the State Landlord Tenant Act, 
                        <a target="_blank" href="https://apps.leg.wa.gov/rcw/default.aspx?cite=59.18.060">Title 59, Section 59.18.060</a> and do not present conditions that endanger or impair the health or safety of the tenants. 
                        <br/><br/>
                        The <a target="_blank" href="https://landlords.bremertonwa.gov/checklist.pdf">Residential Rental Inspection Checklist</a> provides a list of the areas that should be inspected to comply with the standards set forth in RCW <a target="_blank" href="https://apps.leg.wa.gov/rcw/default.aspx?cite=59.18.060">59.18.060</a>. 
                        The checklist does not need to be returned with this application. I understand that if my residential rental properties are found to be in non-compliance
                        with the health and safety requirements outlined in <a target="_blank" href="https://apps.leg.wa.gov/rcw/default.aspx?cite=59.18.060">RCW 59.18.060</a>,
                            that per Bremerton Municipal <a target="_blank" href="https://www.codepublishing.com/WA/Bremerton/html/Bremerton05/Bremerton0506.html">Code 5.06</a>, code enforcement action may be taken.

                            <v-divider class="my-4"></v-divider>
                            <v-row>
                                <v-col cols="2">
                                    <v-row justify="end">
                                        <v-checkbox v-model="signature"></v-checkbox>
                                        <v-divider vertical class="mx-4"></v-divider>
                                    </v-row>
                                </v-col>
                                <v-col >
                                    <v-row justify="start">
                                        By checking the box to the left, I certifiy that the properties being rented out are in compliance with standards set forth in the State Landlord Tenant Act, Title 59, Section 59.18.060 
                                    </v-row>
                                </v-col>
                            </v-row>
                    </div>  
                    <div v-else>
                        <v-row class="mt-8  pt-8" justify="center">
                            <h2>Thank you for doing business</h2> 
                        </v-row>
                        <v-row class="mb-8 mt-6 pb-8" justify="center">
                            <h2>with the City of Bremerton!</h2>
                        </v-row>
                    </div>
                    <v-divider class="my-4"></v-divider>
                    <div>
                        Clicking the 'SUBMIT' button below will take you to a secure third party payment site to process the cost of the license. You will recieve an email from the City of Bremerton when the license is approved.
                        <v-divider class="ma-4"></v-divider>
                        The cost of the license is <b>${{bill}}</b>
                    </div>
                </v-card-text>
                <v-divider class="my-4"></v-divider>
                 <v-card-actions>
                   <v-btn @click="step4=false">close</v-btn>
          <v-spacer></v-spacer>
          
          <v-btn
            v-if="signature == true || residential == false"
            color="blue darken-1"
            text
            @click="renew"
          >
            Submit
          </v-btn>
          <v-btn
            v-else
            color="blue darken-1"
            text
            disabled
          >
            Submit
          </v-btn>
        </v-card-actions>
            </v-card>
        </v-dialog>
    <!--  //////////////////////////////////// generic snackbar  -->
     <v-snackbar 
      top
      light
      color="success lighten-4"
      v-model="snackbar"
      elevation="18"
      shaped
      timeout="10000"
      >
      {{ snackbartext }}
    <template v-slot:action>
        <v-btn
          text
          @click="snackbar = false"
          color="success darken-3"
        >
          Close
        </v-btn>
    </template> 
    </v-snackbar>
    <!-- /////////address validation error dialog ///////////////-->
    <v-dialog width="600" v-model="jurisdictionErrorShow">
      <v-card>
        <v-card-title>
          Not A Valid Address
        </v-card-title>
        <v-card-text>
          <v-row class="ma-2">
            <v-divider></v-divider>      
          </v-row>
          <v-row class="mt-4 ml-4">
            <h4>{{ jurisdictionError[0] }}</h4> &nbsp; is not in Bremertons Jurisdiction
          </v-row>
          <v-row class="ml-4">
            That address is under &nbsp; <h4>{{ jurisdictionError[1] }}</h4> &nbsp; jurisdiction
          </v-row>
          <v-row class="ma-4">
            <h5>(You do not need a license from the City of Bremerton for that address)</h5>
          </v-row>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="warning" elevation="12" @click="jurisdictionErrorShow=false">close</v-btn>
          </v-card-actions>
          

        </v-card-text>
      </v-card>
    </v-dialog>

     <!--  /////////////////////////////////// add email dialog  -->
    <v-dialog width="500" persistent v-model="dialogemail">
      <v-card>
        <v-card-title>
          Please Add Email Address
        </v-card-title>
        <v-card-text>
          Please add an email address to your account. You will need a valid email address if you want to change or recover your password in the future, thanks!
            <v-container>
    <v-text-field
      ref="eml"
      v-model="newemail"
      :rules="[rules.required, rules.email]"
      type="Email"
      label="Email Address"
      
    ></v-text-field>
   
  </v-container>
          <v-card-actions>
            <v-row v-if="$refs.eml" justify="end">
              <v-btn v-if="$refs.eml.valid" @click="addemail" class="ma-4" elevation="18" color="success" >Add email</v-btn>
              <v-btn v-if="!$refs.eml.valid" class="ma-4" elevation="2" disabled >Add email</v-btn>
            </v-row>
            <v-row v-else justify="end">
              <v-btn  class="ma-4" elevation="2" disabled >Add email</v-btn>
            </v-row>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>



     <!-- /////////////////////////////// renew dialog  /// -->
     <v-dialog width="500" persistent v-model="dialogrenew">
       <v-card >
         <v-card-title>Renew Landlord License</v-card-title>
         <v-card-text>
           <table>
              <tr><td>Account Number: </td><td> {{account.AcctNo}} </td></tr>
           
              <tr><td>Business Name: </td><td> {{account.BusName}} </td></tr>
           
              
              <tr><td>Current License Expires end of: </td><td> {{account.LicYear}} </td></tr>
              <tr><td>Renewal Fee: </td><td align="right"> <b>${{bill}}</b> </td></tr>
              <tr><td>Late Penalty: </td><td align="right"> <b>${{penalty}}</b> </td></tr>
              <tr><td>Balance Forward: </td><td align="right"> <b>${{balfor}}</b> </td></tr>
              <tr><td>Total: </td><td> <h2 align="right">${{total}}</h2> </td></tr>
              
           </table>
           <v-row class="mt-6 mb-2" justify="center">
            There will be a late penalty if not renewed by <strong> &nbsp;March 31st</strong>
           </v-row>
         </v-card-text>
         <v-divider></v-divider>
         <v-card-actions class="mx-2 mt-4 pb-4">
          <v-btn v-if="account.renewyear == ''" elevation="12" @click="renew1" dark color="teal darken-2">click here to renew license</v-btn>
           <v-btn v-if="account.renewyear != ''" elevation="12" @click="renew1" dark color="teal darken-2">click here to renew license for {{account.renewyear}}</v-btn>
           <v-spacer></v-spacer>
           <v-btn color="success" @click="dialogrenew = false, dialogmain = true">back</v-btn>
         </v-card-actions>
       </v-card>
    </v-dialog>
     
     <!-- /////////////////////////////// generic dialog  //// -->
    <v-dialog persistent v-model="dialoggeneric" width="400">
      <v-card :color="dialoggenericcolor">
        <v-card-title>{{dialoggenerictitle}}</v-card-title>
        <v-card-text>{{dialoggenerictext}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialoggeneric = false">close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
     
     
     
     
     <!-- ///////////////////////////////pre delete dialog  //// -->
    <v-dialog persistent v-model="dialogDelete" width="400">
      <v-card dark color="red darken-4">
        <v-card-title>Deleting Address</v-card-title>
        <v-card-text>
          <v-row justify="center">
          Are you sure you want to delete this address
          </v-row>
          </v-card-text>
        <v-card-actions>
          <v-btn elevation="12" color="warning" @click="deleteaddress">delete</v-btn>
          <v-spacer></v-spacer>
          <v-btn elevation="12" color="success" @click="dialogDelete = false">close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    

    <!-- //////////////////////////////////  main dialog  ////////////////////////////////// -->
    <v-dialog width="850" v-model="dialogmain" persistent>
      <v-row class="ma-0 pa-4">
        <v-col>
          <v-row justify="center">
           <v-hover v-slot="{ hover }" >
            <v-card 
            class="mt-4"
              width="270"
              height="300"
              :color="hover? 'green lighten-4' : 'grey lighten-2'"
              :elevation="hover? 20 : 12" 
              @click="dialog = true, dialogmain = false">
              <v-img
              class="mt-4"
              src="../assets/update.png"
              contain
              height="100"
              ></v-img>
              <v-card-title>
                View/Update Information
              </v-card-title>
              <v-divider class="ma-0"></v-divider>
              <v-card-text>
                <b>Click here to:</b><br/>
                Update Property Owner Data<br/>
                Update Rental addresses<br/>
                Verify Current Information
              </v-card-text>
            </v-card>
           </v-hover>
        </v-row>
        </v-col>
        
        
        <v-col>
          <v-row justify="center">
          <v-hover v-slot="{ hover }" >
            <v-card 
              class="mt-4"
              width="270"
              height="300"
              :color="hover? 'green lighten-4' : 'grey lighten-2'"
              :elevation="hover? 20 : 12" 
              @click="printpdf">
              <v-img
              class="mt-4"
              src="../assets/license.png"
              height="100"
              contain
              ></v-img>
              <v-card-title>
                Print License
              </v-card-title>
              <v-divider class="ma-0"></v-divider>
              <v-card-text>
                <b>Click here to:</b><br/>
                Print License
              </v-card-text>
            </v-card>
           </v-hover>
           </v-row>
        </v-col>

        <v-col>
          <v-row justify="center">
          <v-hover v-slot="{ hover }" >
            <v-card 
              class="mt-4"
              width="270"
              height="300"
              :color="hover? 'green lighten-4' : 'grey lighten-2'"
              :elevation="hover? 20 : 12" 
              @click="dialogrenew = true, dialogmain = false">
              <v-img
              class="mt-4"
              src="../assets/license.png"
              height="100"
              contain
              ></v-img>
              <v-card-title>
                Renew License
              </v-card-title>
              <v-divider class="ma-0"></v-divider>
              <v-card-text>
                <b>Click here to:</b><br/>
                Update License Year<br/>
                Pay License Renewal<br/>
                Verify Current License
              </v-card-text>
            </v-card>
           </v-hover>
           </v-row>
        </v-col>
        
      </v-row>
      <v-row class="my-4 mr-1">
        <v-spacer></v-spacer>
        <v-btn @click="logout" color="teal" elevation="4" class="mr-3">log out</v-btn>
      </v-row>
     </v-dialog>



    <!-- /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////-->
    <!--                                                        dialog to update address   (popup)                                            -->
    <!-- /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////-->

      <v-dialog content-class="top-dialog-hey" persistent max-width="600" v-model="dialogaddress">
        <v-card max-width="600" class="pa-4" >
          <v-row class="pa-4">
            <h2>Address</h2> <v-spacer></v-spacer> 
            <v-btn @click="addaddress" v-if="!updateaddress.prikey" color="success">Add</v-btn>
            <v-btn @click="updateaddresscall" v-if="updateaddress.prikey" color="success">Update</v-btn>
            <v-btn class="ml-2" @click="predelete" v-if="updateaddress.prikey" color="error">Delete</v-btn>
            <v-btn class="ml-2" @click="dialogaddress = false, vaddressesshow = false" color="warning">Close</v-btn>
          </v-row>
          <v-card-text>
            <v-sheet elevation="12" class="pa-6 mt-4" color="teal lighten-5">
            <v-row>
              <v-text-field @input="validateAddress"  filled outlined dense label="Line 1" v-model="updateaddress.AddrOtherAdr1"></v-text-field>
            </v-row>
            <v-expand-transition>
            <v-row v-if="vaddressesshow">
              <v-spacer></v-spacer> click on the address below (showing top {{ vaddresses.length }} results)<v-spacer></v-spacer> 
                <v-data-table
                  :headers="vheaders"
                  :items="vaddresses"
                  class="elevation-1"
                  dense
                  @click:row="verifiedAddress"
                  >
                </v-data-table>
              
            </v-row>
          </v-expand-transition>
            <v-row>
              <v-text-field @click="vaddressesshow=false"  filled outlined dense label="Line 2" v-model="updateaddress.AddrOtherAdr2"></v-text-field>
            </v-row>
            <v-row>
              <v-text-field @click="vaddressesshow=false" filled outlined dense label="Line 3" v-model="updateaddress.AddrOtherAdr3"></v-text-field>
            </v-row>
            <v-row justify="center">
              <v-col cols="6" class="ma-0 pa-0">
                <v-text-field filled  outlined dense @click="vaddressesshow=false" label="City" v-model="updateaddress.AddrOtherCity"></v-text-field>
              </v-col>
              <v-col class="ma-0 pa-0">
                <v-row class="mx-2 px-2 py-0 my-0" justify="center">
                  <v-text-field filled outlined dense @click="vaddressesshow=false"  label="State" v-model="updateaddress.AddrOtherState"></v-text-field>
                </v-row>
              </v-col>
              <v-col class="my-0 pa-0">
                <v-text-field filled outlined dense @click="vaddressesshow=false" label="Zip" v-model="updateaddress.AddrOtherZip"></v-text-field>
              </v-col>
              
            </v-row>
            <v-row class="ma-0 pa-0">
                <v-col class="ma-0 pa-0">
                  <v-row justify="start" class="mr-0 mt-1">
                    <v-text-field @click="vaddressesshow=false" width="20" class="mt-0 ml-0 mr-12" type="number" v-model="updateaddress.AddrOtherMisc" dense outlined persistent-placeholder="" label="# of Units"></v-text-field>
                  </v-row>
                </v-col>
                <v-col class="ma-0 pa-0">
                    <v-row justify="end">
                        <v-radio-group row v-model="updateaddress.AddrType"  class="mt-5 pa-0">
                            <v-radio @click="vaddressesshow=false" value="residential" label="Residential"></v-radio>
                            <v-radio @click="vaddressesshow=false" value="commercial" label="Commercial"></v-radio>
                        </v-radio-group>
                    </v-row>
                </v-col>   
            </v-row>
            </v-sheet>
            
          </v-card-text>
        </v-card>


      </v-dialog>
    <!-- /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////-->
    <!--                                                  END  dialog to update address                                                       -->
    <!-- /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////-->
    <!--  //////////////////////////////black header    -->
    <v-sheet dark class="ma-0 pa-0" color="black" height="30" width="100%">
      <v-row class="mr-2 mt-1">
       <v-spacer></v-spacer> Property Owner
      </v-row>
    </v-sheet>
    <!-- /////////////////////////////end header  -->
      <v-row>
        <v-col>
          <v-row class="ma-4" justify="center">
    <!-- ////////////////////////////////////////////////////////////////////////////////////////////// -->
    <!-- ///////////////////////////////////////////////////////main display/////////////////////////// -->
    <!-- ////////////////////////////////////////////////////////////////////////////////////////////// -->
            <v-card elevation="12" max-width="900" color="teal lighten-4" v-if="dialog" class="ma-4 pa-0">
              <v-sheet dark class="ma-0 pa-0" color="teal darken-4" height="30" width="100%">
                <v-row class="ml-2 pt-1">
                Property Owner information
                </v-row>
              </v-sheet>
                <v-card-text>
                  <v-row>
                    <v-col>
                      Account: <b>{{account.AcctNo}}</b><br/>
                      Lic. Year: <b>{{account.LicYear}}</b><br/>
                      Status: <b>{{account.Status}}</b>
                    </v-col>
                    <v-col>
                      <v-row>
                        <v-spacer></v-spacer>
                         <v-btn @click="dialog = false, dialogmain = true" class="mr-4 mt-5" height="50" color="success darken-4">Back</v-btn>
                        <v-btn @click="updatedata" class="mr-4 mt-5" height="50" color="success darken-4">click here to Update</v-btn>
                      </v-row>
                    </v-col>
                  </v-row>
                  

                <v-row class="mt-4 pa-0">
                    <v-col class="mt-0 pt-0" cols="12" sm="6" md="6">
                      <v-text-field :background-color="bc" readonly persistent-placeholder placeholder=" " dense outlined label="Name" v-model="account.BusName"></v-text-field>
                    </v-col>
                    <v-col class="mt-0 pt-0" cols="12" sm="6" md="6">
                      <v-text-field :background-color="bc" readonly persistent-placeholder placeholder=" " dense outlined label="Email" v-model="account.EMail"></v-text-field>
                    </v-col>
                    <v-col class="mt-0 pt-0" cols="12" sm="6" md="6">
                      <v-text-field :background-color="bc" readonly persistent-placeholder placeholder=" " dense outlined label="Phone" v-model="account.Phone"></v-text-field>
                    </v-col>
                </v-row>

            <!-- ///////////////////////////////////////////Local and Mailing addresses////////////////////// -->
    <v-sheet
      width="100%"
      dark
      color="success darken-4"
    >
    <h4 class="pa-2">Property Owner Contact Information</h4>
    </v-sheet>


<v-tabs
 dark
 background-color="success darken-4"
 vertical>
  <v-divider></v-divider>
      <v-tab >
        <v-row class="ml-0">
          <v-icon left>
            mdi-email
          </v-icon>
          Mailing<br/>Address
        </v-row>        
      </v-tab>
      <v-divider></v-divider>
      <v-tab>
        <v-row class="ml-0">
          <v-icon left>
          mdi-home-map-marker
        </v-icon>
        Physical<br/>Address
        </v-row>
      </v-tab>
      
      <v-tab-item>
        <!--  //////////////////////////////////////////////Mailing Address Card -->
           <v-card :color="c"  outlined shaped elevation="3" min-width="360">
            <v-card-title>
              Landlord Mailing Address
            </v-card-title>
            <v-card-text>
              <v-text-field :background-color="bc" readonly persistent-placeholder placeholder=" " dense outlined label="line 1" v-model="account.MailAdr1"></v-text-field>
              <v-text-field :background-color="bc" readonly persistent-placeholder placeholder=" " dense outlined label="line 2" v-model="account.MailAdr2"></v-text-field>
              <v-text-field :background-color="bc" readonly persistent-placeholder placeholder=" " dense outlined label="line 3" v-model="account.MailAdr3"></v-text-field>
              <v-text-field :background-color="bc" readonly persistent-placeholder placeholder=" " dense outlined label="City" v-model="account.MailCity"></v-text-field>
              <v-row>
                <v-col>
                  <v-text-field :background-color="bc" readonly persistent-placeholder placeholder=" " dense outlined label="State" v-model="account.MailState"></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field :background-color="bc" readonly persistent-placeholder placeholder=" " dense outlined label="Zip" v-model="account.MailZip"></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
      </v-tab-item>
      <v-tab-item>      
      <!-- /////////////////////////////////////////////////////Physical Address Card -->
         <v-card  outlined shaped elevation="3" min-width="360" :color="c">
            <v-card-title>
              Landlord Physical Address 
            </v-card-title>
            <v-card-text>
              <v-text-field :background-color="bc" readonly persistent-placeholder placeholder=" " dense outlined label="line 1" v-model="account.LocAdr1"></v-text-field>
              <v-text-field :background-color="bc" readonly persistent-placeholder placeholder=" " dense outlined label="line 2" v-model="account.LocAdr2"></v-text-field>
              <v-text-field :background-color="bc" readonly persistent-placeholder placeholder=" " dense outlined label="line 3" v-model="account.LocAdr3"></v-text-field>
              <v-text-field :background-color="bc" readonly persistent-placeholder placeholder=" " dense outlined label="City" v-model="account.LocCity"></v-text-field>
              <v-row>
                <v-col>
                  <v-text-field :background-color="bc" readonly persistent-placeholder placeholder=" " dense outlined  label="State" v-model="account.LocState"></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field :background-color="bc" readonly persistent-placeholder placeholder=" " dense outlined label="Zip" v-model="account.LocZip"></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
      </v-tab-item>       
      <v-tab-item>
      <!--  //////////////////////////////////////////// Secondary Contact Card -->  
          <v-card :color="c"  outlined shaped elevation="3" min-width="360">
            <v-card-title>
              Property Owner Secondary Contact
            </v-card-title>
            <v-card-text>
              <v-row>

                <v-col class="mt-8">
                  <v-text-field :background-color="bc" readonly persistent-placeholder placeholder=" " dense outlined label="Name" v-model="sc.AddrOtherName"></v-text-field>
                  <v-text-field :background-color="bc" readonly persistent-placeholder placeholder=" " dense outlined label="Title" v-model="sc.AddrOtherMisc"></v-text-field>
                  <v-text-field :background-color="bc" readonly persistent-placeholder placeholder=" " dense outlined label="Phone" v-model="sc.AddrOtherPhone"></v-text-field>
                  <v-text-field :background-color="bc" readonly persistent-placeholder placeholder=" " dense outlined label="Email" v-model="sc.AddrOtherEMail"></v-text-field>
                </v-col>
                <v-divider vertical></v-divider>
                <v-col>
                  <v-text-field :background-color="bc" readonly persistent-placeholder placeholder=" " dense outlined label="Address line 1" v-model="sc.AddrOtherAdr1"></v-text-field>
                  <v-text-field :background-color="bc" readonly persistent-placeholder placeholder=" " dense outlined label="Address line 2" v-model="sc.AddrOtherAdr2"></v-text-field>
                  <v-text-field :background-color="bc" readonly persistent-placeholder placeholder=" " dense outlined label="Address line 3" v-model="sc.AddrOtherAdr3"></v-text-field>
                  <v-text-field :background-color="bc" readonly persistent-placeholder placeholder=" " dense outlined label="City" v-model="sc.AddrOtherCity"></v-text-field>
                  <v-row>
                    <v-col>
                      <v-text-field :background-color="bc" readonly persistent-placeholder placeholder=" " dense outlined label="State" v-model="sc.AddrOtherState"></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field :background-color="bc" readonly persistent-placeholder placeholder=" " dense outlined label="Zip" v-model="sc.AddrOtherZip"></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
                
            </v-row>
            </v-card-text>
          </v-card>
      </v-tab-item>
</v-tabs>

                
                </v-card-text>
            </v-card>

            <v-card
             color="teal lighten-4"
             elevation="12"
             v-if="dialog" 
             max-width="900"
             class="ma-4 pa-0"
            >
            <v-sheet dark class="ma-0 pa-0" color="teal darken-4" height="30" width="100%">
                <v-row class="ml-2 pt-1">
                Rental Addresses 
                </v-row>
              </v-sheet>
              <v-card-text>
                  <!-- //////////////////////////////////////Rental Addresses////////////////////////////////////// -->
                  <v-row>
                    <v-col>
                      <v-sheet :color="c" >
                        <v-row class="mx-4 mt-0 pa-4">
                          <h4>Click on a Row to Edit or Delete an Address &nbsp;&nbsp;</h4> <v-spacer></v-spacer>
                            <v-btn color="success darken-4" @click="dialog = false, dialogmain = true"  class="mt-0 pt-0 mr-2" small>Back</v-btn>
                            <v-btn color="success darken-4" @click="addnew" class="mt-0 pt-0" small>Add new Address</v-btn>
                        </v-row>
                        <v-data-table
                        :headers="headers"
                        :items="addresses"
                        class="elevation-12"
                        @click:row="otheraddress"
                        ></v-data-table>
                      </v-sheet>
                    </v-col>
                  </v-row>
                  <!-- //////////////////////////////////////end rental addresses////////////////////////////////// -->
                </v-card-text>
                
            </v-card>
    <!-- ////////////////////////////////////////////////////////////////end main display///////////////////////////////-->
          </v-row>
        </v-col>
      </v-row>
      <pdf class="ma-0 pa-0" ref="pdf"></pdf>
  </v-app>
</template>

<script>
import axios from 'axios'
import pdf from "../components/pdflicense";
export default {
  data(){
    return{
      jurisdictionErrorShow:false,
      jurisdictionError:[],
      step4:false,
      signature:false,
      c:'white',
      ifs:'',
      bc:'blue-grey lighten-5',
      auth:'',
      bill:'75.00',
      balfor:'',
      penalty:'0.00',
      total:0,
      newemail:'',
      password:'',
      account:[],
      addresses:[],
      vaddresses:[],
      vaddressesshow:false,
      updateaddress:[],
      dialoggeneric:false,
      dialoggenericcolor:"warning",
      dialoggenerictitle:"",
      dialoggenerictext:"",
      dialogemail:false,
      dialog:false,
      dialogmain:false,
      dialogDelete:false,
      dialogaddress:false,
      dialogrenew:false,
      residential:false,
      snackbar:false,
      snackbartext:'',
      sc:{
        AcctDb:'R',
        AcctNo:'',
        AddrOtherAdr1:'',
        AddrOtherAdr2:'',
        AddrOtherAdr3:'',
        AddrOtherCity:'',
        AddrOtherEMail:'',
        AddrOtherExt:'',
        AddrOtherMisc:'Secondary Contact',
        AddrOtherName:'',
        AddrOtherPhone:'',
        AddrOtherState:'',
        AddrOtherTitle:'',
        AddrOtherZip:'',
        AddrType:'',
        prikey:'',
      },
      vheaders:[
                //{text:'Type', value:'AddrType'},
                //{text:'Title', value:'AddrOtherTitle'},
                {text:'Address', value:'attributes.FULL_ADDR'},
                {text:'Jurisdiction', value:'attributes.JURISDICT'},
                
            ],
      headers:[
                //{text:'Type', value:'AddrType'},
                //{text:'Title', value:'AddrOtherTitle'},
                {text:'Line 1', value:'AddrOtherAdr1'},
                {text:'Line 2', value:'AddrOtherAdr2'},
                {text:'Line 3', value:'AddrOtherAdr3'},
                //{text:'City', value:'AddrOtherCity'},
                //{text:'State', value:'AddrOtherState'},
                //{text:'Zip', value:'AddrOtherZip'},
                {text:'Units', value:'AddrOtherMisc'},
            ],
      rules: {
          required: value => !!value || 'Required.',
          counter: value => value.length <= 20 || 'Max 20 characters',
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Invalid e-mail.'
          },
        },  
    }
  },
  components: {
        pdf,
    },
  methods:{
    validateAddress(){
      this.vaddressesshow=true;
      window.console.log("validating address");
      let thisvue=this;
      let valurl="https://arcgis.bremertonwa.gov/arcgis/rest/services/Basemaps/Simple_Basemap/MapServer/0/query";
      let adr1 = this.updateaddress.AddrOtherAdr1;

      const params = new URLSearchParams();
      params.append('resultRecordCount', '15');
      params.append('f', 'pjson');
      params.append('outFields', 'FULL_ADDR,JURISDICT');
      params.append('where', "FULL_ADDR like '%"+adr1+"%'");
      console.log(params);
        axios({
            method:"post",
            url:valurl,
            data:params
        })
        .then(function(response){
          let r=response.data.features;
          let x;
          for(x in r){
            //let j=r[x].attributes.JURISDICT;
            switch(r[x].attributes.JURISDICT){
              case 'BR':
                r[x].attributes.JURISDICT="Bremerton";
                break;
              case 'PO':
                r[x].attributes.JURISDICT="Port Orchard";
                break;
              case 'PB':
                r[x].attributes.JURISDICT="Poulsbo";
                break;
              case 'CO':
                r[x].attributes.JURISDICT="County";
                break;
              case 'BI':
                r[x].attributes.JURISDICT="Bainbridge Island";
                break;


            }
          thisvue.vaddresses=r;
          }
        });

    },
    printpdf(){
      //first check if the license is expired
     let ly=parseInt(this.account.LicYear);
     let currentyear= new Date().getFullYear(); 
     if(!ly){
      ly=currentyear;
      this.account.LicYear=ly;
     }

     window.console.log("license year"+ly);
     window.console.log(currentyear);
     if(currentyear-ly > 0){
       //license expired
       //popup to show license expired
       this.snackbar=true;
       this.snackbartext="Can not print license, license is not current. Please renew your license"
     }else{
       //pop up to show printing license
        this.snackbar=true;
        this.snackbartext="Your license PDF file will download shortly";
        this.$store.commit('setaccountinfo',this.account);
        this.$store.commit('setaddressinfo',this.addresses);
        this.$refs.pdf.getdatans();
     }

    
    },
    updatedata(){
      this.$store.commit('setaccountinfo',this.account);
      this.$store.commit('setaddressinfo',this.addresses);
      this.$store.commit('setscinfo',this.sc);
      this.$router.replace({name:"updatedata"});
    },
    addemail(){
       let url = this.$store.state.url;
        let thisvue=this;
        let e=this.newemail;
        let p=this.account.prikey;
        let d=JSON.stringify({'email':e,'prikey':p});
        const params = new URLSearchParams();
        params.append('ty', 'addemail');
        params.append('data', d);
        console.log(d);
        console.log(params);
        axios({
            method:"post",
            url:url,
            data:params
        })
        .then(function(){
          thisvue.dialogemail=false;
          thisvue.dialogmain=true;
        });
    },
    checkprorate(){
      ///// check for late penalty
      let d1=new Date();
      //used to find customer account year
      let dx=parseInt(this.account.LicYear)+1;
      let d2=new Date(dx.toString()+"-4-01");

      // logic to check for if renewal date falls on a weekday
      // let checkday=d2.getDay();
      // if (checkday==0){
      //   d2=new Date(dx.toString()+"-4-2");
      // }
      // if (checkday==6){
      //   d2=new Date(dx.toString()+"-4-3");
      // }

      let d1t=parseInt(d1.getTime()/1000);
      let d2t=parseInt(d2.getTime()/1000);
      let dcheck=Math.floor((d1t-d2t)/60/60/24);


      if(dcheck>0){
        this.penalty='50.00';
      }
      
      this.total=parseFloat(this.bill)+parseFloat(this.penalty)+parseFloat(this.balfor);
      this.total=this.total.toFixed(2);
      
    },
    renew1(){
          this.step4=true;  
    },
    renew(){
          this.step4=false;
          let phone='';
          let email='';
            //this.bill=this.checkprorate();
            if(this.account.Phone){
              phone = this.account.Phone.trim();
            }
            let phone1=phone.substring(0,3);
            let phone2=phone.substring(3,6);
            let phone3=phone.substring(6);
            if(this.account.EMail){
              email = this.account.EMail.trim();
              }
            let acno = this.account.AcctNo.trim();
            let bs=this.account.BusName;
            let bsA=bs.split(',');
            let fname = bsA[1];
            let lname = bsA[0];
            let zip = this.account.LocZip;
            //let bill = this.amountpaid.substring(1);
            this.ifs=this.$store.state.url2+"?iframe=true&header.accountNumber="+
            acno+"&header.paymentTypeCode=License&step=2&customer.email="+email+"&header.amount="+this.total+
            "&customer.dayPhone.npa="+phone1+"&customer.dayPhone.nxx="+phone2+"&customer.dayPhone.did="+phone3+
            "&customer.firstName="+fname+"&customer.lastName="+lname+"&customer.address.zipCode="+zip;
            this.ifs=this.ifs.replace("iframe=true&","");
            window.open(this.ifs, "_blank");
            this.sendemail();
            //this.home();
    },
    sendemail(){
            // let thisvue = this;
            let url = this.$store.state.url;
            let p=this.account.prikey;
            let i=this.ifs;
            let data={1:p,2:i};
             data=JSON.stringify(data);

            const params = new URLSearchParams();
            params.append('ty', 'sendemail2');
            params.append('data',data);
            
                        
            axios({
                method:"post",
                url:url,
                data:params
            })
            .then(function(response){
              window.console.log(response.data);
            });           
        },
    logout(){
      let a="";
      let e="";
      this.$store.commit('setAuth','no');
      this.$store.commit('setUsername','');
      this.$store.commit('setacem',{a,e});
      this.$router.replace({ name: "home" });
    },
    deleteaddress(){
       let url = this.$store.state.url;
        let thisvue=this;
        let d=this.updateaddress.prikey;
        const params = new URLSearchParams();
        params.append('ty', 'deleteaddress');
        params.append('data', d);
        axios({
            method:"post",
            url:url,
            data:params
        })
        .then(function(response){
          if(response.data == "good"){
              thisvue.dialogDelete = false;
             thisvue.dialogaddress = false;
             thisvue.getaddresses();
           }else{
             thisvue.dialoggeneric=true;
             thisvue.dialoggenericcolor="red lighten-4";
             thisvue.dialoggenerictitle="Unable to delete address";
             thisvue.dialoggenerictext="The database was unable to complete you address deletion. Please call the City of Bremerton for assistance";
           }
        });
    },
    predelete(){
        this.vaddressesshow = false;
        this.dialogDelete=true;
      },
    addaddress(){
      this.vaddressesshow = false;
      // need to validate that the dields have values in them
      if(this.updateaddress.AddrOtherAdr1==''){
        this.snackbartext="Line 1 is empty";
        this.snackbar=true;
        return
      }
      if(this.updateaddress.AddrOtherMisc=='' || !this.updateaddress.AddrOtherMisc){
        this.snackbartext="# of units is empty";
        this.snackbar=true;
        return
      }else{
        console.log("units is "+this.updateaddress.AddrOtherMisc)
      }
      if(this.updateaddress.AddrType==''){
        this.snackbartext="type of unit is not selected";
        this.snackbar=true;
        return
      }

      //let a=this.$store.state.account;
      let url = this.$store.state.url;
        let thisvue=this;
        this.updateaddress.BusName = this.account.BusName;
        let d=JSON.stringify(this.updateaddress);
        const params = new URLSearchParams();
        params.append('ty', 'addaddress');
        params.append('data', d);
        axios({
            method:"post",
            url:url,
            data:params
        })
        .then(function(response){
          if(response.data == "good"){
             thisvue.dialogaddress = false;
             thisvue.snackbartext="The address will show up in your account once it is reviewed by the city";
             thisvue.snackbar=true;
             //thisvue.getaddresses();
           }else{
             thisvue.dialoggeneric=true;
             thisvue.dialoggenericcolor="red lighten-4";
             thisvue.dialoggenerictitle="Unable to add address";
             thisvue.dialoggenerictext="The database was unable to complete you new address insert. Please call the City of Bremerton for assistance";
           }
        });
    },
    updateaddresscall(){
      this.vaddressesshow = false;
      //let a=this.$store.state.account;
      let url = this.$store.state.url;
        let thisvue=this;
        this.updateaddress.BusName = this.account.BusName;
        let d=JSON.stringify(this.updateaddress);
        const params = new URLSearchParams();
        params.append('ty', 'updateaddress');
        params.append('data', d);
        axios({
            method:"post",
            url:url,
            data:params
        })
        .then(function(response){
           if(response.data == "good"){
             thisvue.dialogaddress = false;
             thisvue.snackbartext="The address will show up in your account once it is reviewed by the city";
             thisvue.snackbar=true;
             //thisvue.getaddresses();
           }else{
            thisvue.dialoggeneric=true;
             thisvue.dialoggenericcolor="red lighten-4";
             thisvue.dialoggenerictitle="Unable to add address";
             thisvue.dialoggenerictext="The database was unable to complete you address update. Please call the City of Bremerton for assistance";
           }
            
        });
    },
    addnew(){
      this.updateaddress={
          AcctDb:'R',
          AcctNo:this.account.AcctNo,
          AddrOtherAdr1:'',
          AddrOtherAdr2:'',
          AddrOtherAdr3:'',
          AddrOtherCity:'Bremerton',
          AddrOtherState:'Wa',
          AddrOtherZip:'',
          AddrOtherTitle:'',
          AddrType:'',
          AddrOtherPhone:'',
          AddrOtherName:'',
          AddrOtherEMail:''
          };
      this.dialogaddress=true;
    },
    getdata(){
      let a=this.$store.state.account;
      let url = this.$store.state.url;
        let thisvue=this;
        const params = new URLSearchParams();
        params.append('ty', 'getaccountdata');
        params.append('data', a);
        axios({
            method:"post",
            url:url,
            data:params
        })
        .then(function(response){
            let l=parseInt(response.data.LicYear);
            if(l){
              response.data.renewyear=l+1;
            }else{
              response.data.renewyear="";
            }
            thisvue.balfor=response.data.balfor.toFixed(2);
            thisvue.account=response.data;
            thisvue.fixnulls()
            thisvue.checkprorate();
            thisvue.getaddresses();
            //check for email
            let emailcheck = response.data.EMail;
            if(!emailcheck || emailcheck == ''){
               thisvue.dialogemail = true;
            }else{
              //check if updated account
                let x=thisvue.$store.state.urlhistory;


                if(x=="updatedata"){
                    thisvue.dialogmain=false;
                    thisvue.dialog=true;
                }else{
                    thisvue.dialogmain=true;
                    thisvue.dialog=false;
                }
            }
            
        });
    },
    otheraddress(value){
      this.updateaddress=value;
      this.dialogaddress=true;
    },
    verifiedAddress(value){
      let a=value.attributes.FULL_ADDR;
      let b=value.attributes.JURISDICT;
      if(b=='Bremerton'){
        this.updateaddress.AddrOtherAdr1=a;
        this.jurisdictionError=[];
        this.jurisdictionErrorShow=false;
      }else{
        this.updateaddress.AddrOtherAdr1='';
        this.jurisdictionError[0]=a;
        this.jurisdictionError[1]=b;
        this.jurisdictionErrorShow=true;
      }
      
      this.vaddressesshow=false;
      console.log(b);
    },
    getaddresses(){
      let a=this.$store.state.account;
      let url = this.$store.state.url;
        let thisvue=this;
        const params = new URLSearchParams();
        params.append('ty', 'getaddressdata');
        params.append('data', a);
        axios({
            method:"post",
            url:url,
            data:params
        })
        .then(function(response){
          let x;
          let y=[];
          
            for(let i=0;i<response.data.length;i++){
              //search for 'Secondary Contact'
              x=response.data[i].AddrType.trim();
              if(x=='Secondary Contact'){
                thisvue.sc=response.data[i];
              }else{
                y.push(response.data[i]);
              }
              //check if rentals are residential
              if(x=='residential'){thisvue.residential=true;}
            }
            thisvue.addresses=y;
        });
    },
    fixnulls(){
      console.log(this.account)
      let x
      for(x in this.account){
        this.account[x] = this.account[x] ?? '';
        if(this.account[x] == 'null'){this.account[x] = ''}
        console.log(this.account[x])
      }
      
      
    }
  },
  mounted() {
      
      window.scrollTo(0,0);
      
      let a=this.$store.state.Auth;
      this.auth=a;
      if(a != "yes"){
        this.$router.replace({ name: "home" });
      }
      this.getdata();
      if(this.$store.state.urlhistory == "updatedata"){
        this.snackbartext="The updates will show up in your account once it is reviewed by the city";
        this.snackbar=true;
        this.$store.commit('setUrlHistory','loggedin');
      }else{
        this.$store.commit('setUrlHistory','loggedin');
      }
    
    

  },
}
</script>

<style>
.top-dialog-hey{
    top: 0;
    position: absolute;
    
  }
table {
  border: 1px solid #1C6EA4;
  background-color: #EEEEEE;
  width: 100%;
  text-align: left;
  border-collapse: collapse;
}
table td, table th {
  border: 1px solid #AAAAAA;
  padding: 3px 2px;
}
table tbody td {
  font-size: 13px;
}
table tr:nth-child(even) {
  background: #D0E4F5;
}
table thead {
  background: hsl(153, 100%, 91%);
  background: -moz-linear-gradient(top, #eef4ec 0%, #9ec496 66%, #4a5a44 100%);
  background: -webkit-linear-gradient(top, #eef4ec 0%, #9ec496 66%, #4a5a44 100%);
  background: linear-gradient(to bottom, #eef4ec 0%, #9ec496 66%, #4a5a44 100%);
  border-bottom: 2px solid #444444;
}
table thead th {
  font-size: 15px;
  font-weight: bold;
  color: #FFFFFF;
  border-left: 2px solid #D0E4F5;
}
table thead th:first-child {
  border-left: none;
}

table tfoot {
  font-size: 14px;
  font-weight: bold;
  color: #FFFFFF;
  background: #D0E4F5;
  background: -moz-linear-gradient(top, #dcebf7 0%, #d4e6f6 66%, #D0E4F5 100%);
  background: -webkit-linear-gradient(top, #dcebf7 0%, #d4e6f6 66%, #D0E4F5 100%);
  background: linear-gradient(to bottom, #dcebf7 0%, #d4e6f6 66%, #D0E4F5 100%);
  border-top: 2px solid #444444;
}
table tfoot td {
  font-size: 14px;
}
table tfoot .links {
  text-align: right;
}
table tfoot .links a{
  display: inline-block;
  background: #1C6EA4;
  color: #FFFFFF;
  padding: 2px 8px;
  border-radius: 5px;
}
.expanel{
  background: hsl(153, 100%, 91%);
  background: -moz-linear-gradient(top, #eef4ec 0%, #9ec496 86%, #4a5a44 100%);
  background: -webkit-linear-gradient(top, #eef4ec 0%, #9ec496 86%, #4a5a44 100%);
  background: linear-gradient(to bottom, #eef4ec 0%, #9ec496 86%, #4a5a44 100%);
  border-bottom: 2px solid #444444;
}
</style>